import { Button, Box, useTheme } from '@mui/material';

export const StyledButtonConfirmar = ({
  fontSize,
  height,
  width,
  align = 'end', // 'start' | 'center' | 'end'
  buttonConfirmarSx,
  ...props
}) => {
  const theme = useTheme();

  // Constantes para estilos
  const justifyContentMap = {
    start: 'flex-start',
    center: 'center',
    end: 'flex-end',
  };
  const justifyContent = justifyContentMap[align] || 'flex-start';
  const buttonWidth = width || { xs: '100%', sm: '30%' };
  const buttonHeight = height || { xs: '45px', sm: '50px' };
  const buttonFontSize = fontSize || { xs: '16px', sm: '18px' };

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent,
        width: '100%',
      }}
    >
      <Button
        {...props}
        sx={{
          color: theme.text1 || '#fff',
          border: `1px solid ${theme.primary}`,
          width: buttonWidth,
          fontSize: buttonFontSize,
          fontWeight: 600,
          borderRadius: '8px',
          bgcolor: theme.primary,
          height: buttonHeight,
          boxShadow:
            '0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12)',
          mb: { xs: '8px', sm: 0 },
          mt: '10px',
          transition: 'all 0.3s ease',
          '&:hover': {
            bgcolor: theme.primary,
            boxShadow: '0px 4px 20px rgba(0,0,0,0.2)',
            color: theme.text1,
          },
          '&.Mui-disabled': {
            border: 'none',
            bgcolor: theme.palette.action.disabledBackground,
            color: theme.palette.action.disabled,
          },
          ...buttonConfirmarSx,
        }}
      />
    </Box>
  );
};
